<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <loader :active="loading"/>
        <div class="row d-flex justify-content-center" v-if="!offlineAccount">
            <div class="col-xl-6 col-md-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-user"></i> Tworzenie konta offline
                    </div>
                    <div class="card-body">
                        <form class="needs-validation" @submit.prevent="handleCreate">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="create-email">Email</label>
                                        <input
                                            id="create-email"
                                            v-model="create.email"
                                            :class="{ 'is-invalid': $v.create.email.$error }"
                                            class="form-control"
                                            placeholder="email@gmail.com"
                                            type="email"
                                        />
                                        <div v-if="$v.create.email.$error" class="invalid-feedback">
                                            <span v-if="!$v.create.email.required">Email jest wymagany.</span>
                                            <span v-if="!$v.create.email.email">To musi być poprawny email.</span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="create-password">Hasło</label>
                                        <input
                                            id="create-password"
                                            v-model="create.password"
                                            :class="{ 'is-invalid': $v.create.password.$error }"
                                            class="form-control"
                                            placeholder="123456"
                                            type="password"
                                        />
                                        <div v-if="$v.create.password.$error" class="invalid-feedback">
                                            <span v-if="!$v.create.password.required">Hasło jest wymagane.</span>
                                            <span v-if="!$v.create.password.minLength">Hasło musi mieć co najmniej 6 znaków.</span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="create-confirmPassword">Powtórz Hasło</label>
                                        <input
                                            id="create-confirmPassword"
                                            v-model="create.confirmPassword"
                                            :class="{ 'is-invalid': $v.create.confirmPassword.$error }"
                                            class="form-control"
                                            placeholder="123456"
                                            type="password"
                                        />
                                        <div v-if="$v.create.confirmPassword.$error"
                                             class="invalid-feedback">
                                            <span v-if="!$v.create.confirmPassword.required">Potwierdzenie hasła jest wymagane.</span>
                                            <span v-if="!$v.create.confirmPassword.sameAsPassword">Hasła muszą być takie same.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-around">
                                <button class="btn btn-primary" :disabled="loading">
                                    <span><i class="fa fa-plus"></i> Utwórz konto offline</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="row d-flex justify-content-center" v-else-if="!offlineAccountVerified">
            <div class="col-xl-6 col-md-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-check"></i> Zweryfikuj email do konta offline
                    </div>
                    <div class="card-body">
                        <h6>Wpisany email: {{ offlineAccount }}</h6>
                        <p>Jeśli na tym etapie chcesz zmienić adres email, najpierw usuń konto offline, a potem utwórz nowe.</p>
                        <hr>

                        <form class="needs-validation" @submit.prevent="handleVerify">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="verificationToken">Token</label>
                                        <input
                                            id="verificationToken"
                                            v-model="verificationToken"
                                            :class="{ 'is-invalid': $v.verificationToken.$error }"
                                            class="form-control"
                                            placeholder="*** ***"
                                            type="text"
                                        />
                                        <div v-if="$v.verificationToken.$error" class="invalid-feedback">
                                            <span v-if="!$v.verificationToken.required">Token jest wymagany.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-around">
                                <button class="btn btn-info" :disabled="loading" @click.prevent="resendEmail">
                                    <span><i class="fa fa-envelope"></i> Wyślij ponownie</span>
                                </button>
                                <button class="btn btn-primary" :disabled="loading">
                                    <span><i class="fa fa-check"></i> Zweryfikuj</span>
                                </button>
                                <button class="btn btn-danger" :disabled="loading" @click.prevent="deleteOfflineAccount">
                                    <span><i class="fa fa-trash"></i> Usuń konto offline</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-md-12 mb-3">
                <b-alert :show="true" variant="info" class="d-flex justify-content-between align-items-center">
                    <span><i class="fa fa-info"></i> Jeśli nie pamiętasz obecnego hasła, możesz usunąć konto offline i założyć sobie nowe.</span>
                    <button class="btn btn-danger" @click="deleteOfflineAccount"><i class="fa fa-trash"></i> Usuń konto offline</button>
                </b-alert>
            </div>

            <div class="col-md-6">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-key"></i> Zmiana hasła
                    </div>
                    <div class="card-body">
                        <form class="needs-validation" @submit.prevent="handleChangePassword">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="changePassword-currentPassword">Obecne hasło</label>
                                        <input
                                            id="changePassword-currentPassword"
                                            v-model="changePassword.currentPassword"
                                            :class="{ 'is-invalid': $v.changePassword.currentPassword.$error }"
                                            class="form-control"
                                            type="password"
                                        />
                                        <div v-if="$v.changePassword.currentPassword.$error" class="invalid-feedback">
                                            <span v-if="!$v.changePassword.currentPassword.required">Obecne hasło jest wymagane.</span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="changePassword-password">Nowe hasło</label>
                                        <input
                                            id="changePassword-password"
                                            v-model="changePassword.password"
                                            :class="{ 'is-invalid': $v.changePassword.password.$error }"
                                            class="form-control"
                                            placeholder="123456"
                                            type="password"
                                        />
                                        <div v-if="$v.changePassword.password.$error" class="invalid-feedback">
                                            <span v-if="!$v.changePassword.password.required">Nowe hasło jest wymagane.</span>
                                            <span v-if="!$v.changePassword.password.minLength">Nowe hasło musi mieć co najmniej 6 znaków.</span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="changePassword-confirmPassword">Powtórz nowe hasło</label>
                                        <input
                                            id="changePassword-confirmPassword"
                                            v-model="changePassword.confirmPassword"
                                            :class="{ 'is-invalid': $v.changePassword.confirmPassword.$error }"
                                            class="form-control"
                                            placeholder="123456"
                                            type="password"
                                        />
                                        <div v-if="$v.changePassword.confirmPassword.$error"
                                             class="invalid-feedback">
                                            <span v-if="!$v.changePassword.confirmPassword.required">Potwierdzenie hasła jest wymagane.</span>
                                            <span v-if="!$v.changePassword.confirmPassword.sameAsPassword">Hasła muszą być takie same.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-around">
                                <button class="btn btn-primary" :disabled="loading">
                                    <span><i class="fa fa-edit"></i> Zmień hasło</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-envelope"></i> Zmiana emaila
                    </div>
                    <div class="card-body">
                        <form class="needs-validation" @submit.prevent="handleChangeEmail">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="changeEmail-currentPassword">Obecne hasło</label>
                                        <input
                                            id="changeEmail-currentPassword"
                                            v-model="changeEmail.currentPassword"
                                            :class="{ 'is-invalid': $v.changeEmail.currentPassword.$error }"
                                            class="form-control"
                                            type="password"
                                        />
                                        <div v-if="$v.changeEmail.currentPassword.$error" class="invalid-feedback">
                                            <span v-if="!$v.changeEmail.currentPassword.required">Obecne hasło jest wymagane.</span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="changeEmail-password">Nowy email</label>
                                        <input
                                            id="changeEmail-password"
                                            v-model="changeEmail.email"
                                            :class="{ 'is-invalid': $v.changeEmail.email.$error }"
                                            class="form-control"
                                            placeholder="email@gmail.com"
                                            type="email"
                                        />
                                        <div v-if="$v.changeEmail.email.$error" class="invalid-feedback">
                                            <span v-if="!$v.changeEmail.email.required">Nowy email jest wymagany.</span>
                                            <span v-if="!$v.changeEmail.email.email">Nowe email musi być prawidłowy.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-around">
                                <button class="btn btn-primary" :disabled="loading">
                                    <span><i class="fa fa-edit"></i> Zmień adres email</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-chart-bar"></i> Ostatnie logowania
                    </div>
                    <div class="card-body">
                        <data-table
                            v-if="!loading"
                            :fields="fields"
                            :items="logs"
                        >
                            <template v-slot:action="row">
                                <span>{{ getAction(row.value) }}</span>
                            </template>
                            <template v-slot:description="row">
                                <span v-if="row.value == 'success'" class="text-success"><i class="fa fa-check"></i> Sukces</span>
                                <span v-else class="text-danger"><i class="fa fa-times"></i> Error</span>
                            </template>
                            <template v-slot:created_at="row">
                                {{ row.value | moment("DD-MM-YYYY HH:mm") }}
                            </template>
                        </data-table>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from "../layouts/main";
import PageHeader from "@/components/page-header";
import OfflineAccountService from "@/services/offline-account.service";
import {
    notificationMethods
} from "@/state/helpers";
import {minLength, required, sameAs, email} from "vuelidate/lib/validators";
import Vue from "vue";

/**
 * Starter component
 */
export default {
    name: "OfflineAccount",
    components: {Layout, PageHeader},
    data() {
        return {
            title: "Konto offline",
            items: [
                {
                    text: "Twoje konto",
                    href: "/"
                },
                {
                    text: "Konto offline",
                    active: true
                }
            ],
            loading: true,
            create: {},
            changePassword: {},
            changeEmail: {},
            verificationToken: '',
            loadingLogs: true,
            logs: [],
            fields: [
                {key: "action", label: "Akcja"},
                {key: "description", label: "Typ"},
                {key: "details", label: "Więcej informacji"},
                {key: "ip", label: "IP"},
                {key: "browser", label: "Przeglądarka"},
                {key: "created_at", label: "Data"},
            ],
        };
    },
    validations: {
        create: {
            email: {required, email: email},
            password: {required, minLength: minLength(6)},
            confirmPassword: {required, sameAsPassword: sameAs('password')},
        },
        changePassword: {
            currentPassword: {required},
            password: {required, minLength: minLength(6)},
            confirmPassword: {required, sameAsPassword: sameAs('password')},
        },
        changeEmail: {
            currentPassword: {required},
            email: {required, email: email}
        },
        verificationToken: {required: required}
    },
    computed: {
        offlineAccount() {
            return this.$store.getters['auth/user'].offlineAccount;
        },
        offlineAccountVerified() {
            return this.$store.getters['auth/user'].offlineAccountVerified;
        }
    },
    mounted() {
        this.loading = false;
        this.loadLogs();
    },
    methods: {
        ... notificationMethods,
        loadLogs() {
            this.loadingLogs = true;

            OfflineAccountService.getLogs().then(
                response => {
                    this.logs = response.data;
                    this.loadingLogs = false;
                },
                error => {
                    console.log(error);
                    this.loadingLogs = false;
                }
            )
        },
        getAction(action) {
            return action.includes('Online') ? 'Logowanie przez token' : 'Logowanie offline';
        },
        handleCreate() {
            this.$v.create.$touch();

            if (this.$v.create.$invalid) {
                return;
            } else {
                this.loading = true;

                OfflineAccountService.create(this.create).then(
                    () => {
                        this.refreshClientInfo();
                        this.success("Konto offline zostało utworzone. Teraz zweryfikuj adres email.");
                    },
                    error => {
                        console.log(error);
                        this.loading = false;
                    }
                )
            }
        },
        handleVerify() {
            this.$v.verificationToken.$touch();

            if (this.$v.verificationToken.$invalid) {
                return;
            } else {
                this.loading = true;

                OfflineAccountService.verifyEmail(this.verificationToken).then(
                    () => {
                        this.verificationToken = '';
                        this.$v.verificationToken.$reset();
                        this.success("Email został zweryfikowany");
                        this.refreshClientInfo();
                    },
                    error => {
                        console.log(error);
                        this.loading = false;
                    }
                )
            }
        },
        resendEmail() {
            this.$v.verificationToken.$reset();
            this.loading = true;

            OfflineAccountService.resendEmail().then(
                () => {
                    this.loading = false;
                    this.success("Email został wysłany");
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        deleteOfflineAccount() {
            Vue.swal.fire({
                title: 'Jesteś pewny?',
                text: "Nie będziesz mógł cofnąć tej operacji!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Tak, usuń!',
                cancelButtonText: 'Anuluj'
            }).then((result) => {
                if (result.value) {
                    this.loading = true;

                    OfflineAccountService.deleteOfflineAccount().then(
                        () => {
                            this.refreshClientInfo();
                            this.success("Konto zostało usunięte");
                        },
                        error => {
                            console.log(error);
                            this.loading = false;
                        }
                    )
                }
            });
        },
        handleChangePassword() {
            this.$v.changePassword.$touch();

            if (this.$v.changePassword.$invalid) {
                return;
            } else {
                this.loading = true;

                OfflineAccountService.changePassword(this.changePassword).then(
                    () => {
                        this.loading = false;
                        this.changePassword = {};
                        this.$v.changePassword.$reset();
                        this.success("Hasło zostało zmienione");
                    },
                    error => {
                        console.log(error);
                        this.loading = false;
                    }
                )
            }
        },
        handleChangeEmail() {
            this.$v.changeEmail.$touch();

            if (this.$v.changeEmail.$invalid) {
                return;
            } else {
                this.loading = true;

                OfflineAccountService.changeEmail(this.changeEmail).then(
                    () => {
                        this.changeEmail = {};
                        this.$v.changeEmail.$reset();
                        this.success("Email został zmieniony. Teraz musisz go zweryfikować");
                        this.refreshClientInfo();
                    },
                    error => {
                        console.log(error);
                        this.loading = false;
                    }
                )
            }
        },
        refreshClientInfo() {
            this.$store.dispatch('auth/refreshClientInfo', true).then(() => {
                this.loading = false;
            }, 2*1000);
        }
    }
};
</script>